'use client';

import React from 'react';
import type { StoryObject } from '@benzinga/advanced-news-manager';
import { NewsListItemElement } from '@benzinga/news';
import { isDesktop as isDesktopViewport } from '@benzinga/device-utils';

const topicUrl = (topic: string) =>
  `https://www.benzinga.com/topic/${topic
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')}`;

interface LearnTopicNewsProps {
  news?: StoryObject[];
  topic?: string;
}

export const LearnTopicNews: React.FC<LearnTopicNewsProps> = ({ news, topic }) => {
  const [isDesktop, setIsDesktop] = React.useState(false);

  React.useEffect(() => {
    const update = () => setIsDesktop(isDesktopViewport());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  if (!isDesktop) return null;
  if (!Array.isArray(news) || news.length === 0) return null;

  return (
    <section className={`mt-6 border-t-[3px] border-t-bzblue-700 bg-bzblue-1100 p-4`}>
      <h2 className="m-0 mb-4 text-xl font-bold leading-tight text-white">
        {topic ? `Get Latest ${topic} News` : 'Get Latest News'}
      </h2>
      <div className="flex flex-col gap-3">
        {news.map(article => (
          <div
            className={
              'rounded-lg bg-white p-3 text-gray-900 [&_.teaser-text]:text-[0.8125rem] [&_.title-text]:text-[0.9375rem]'
            }
            key={article.id ?? article.title}
          >
            <NewsListItemElement
              node={article}
              showCommentsIcon={false}
              showImage={false}
              showTeaser
              showTicker={false}
            />
          </div>
        ))}
      </div>
      {topic && (
        <a
          className="mt-3 block rounded-lg bg-bzblue-700 px-3 py-2.5 text-center text-sm font-bold text-white hover:bg-bzblue-600"
          href={topicUrl(topic)}
        >
          Get More News
        </a>
      )}
    </section>
  );
};

export default LearnTopicNews;
